export const syncCalendar = {
  title: "Synchronizacja kalendarzy",
  description:
    "Czy obiekt jest wystawiony w kilku serwisach? Synchronizacja kalendarzy pozwala zobaczyć rezerwacje i dostępność we wszystkich kanałach naraz. Kalendarze można importować i eksportować w formacie iCal oraz utrzymywać aktualną listę zaplanowanych check-inów.",
  accommodation: "Obiekt",
  sync: "Synchronizuj",
  addCalendar: "Dodaj nowy kalendarz",
  confirmSync: {
    message: "Czy zaktualizować kalendarze?",
  },
  syncSuccess: {
    message: "Kalendarze zostały zsynchronizowane",
    title: "Synchronizacja zakończona",
  },
  calendarName: "Nazwa kalendarza",
  modal: {
    header: "Dodaj kalendarz",
    nameLabel: "Proszę wpisać nazwę kalendarza",
    linkLabel: "Proszę skopiować i wkleić tutaj link do kalendarza",
    linkPlaceholder: "Link iCal",
    cancel: "Anuluj",
    save: "Zapisz i synchronizuj",
  },
  saveSuccess: {
    message: "Gotowe",
    title: "Kalendarz został zapisany",
  },
  errors: {
    validationTitle: "Weryfikacja nie powiodła się",
    saveErrorTitle: "Błąd zapisu kalendarza",
    unexpected: "Wystąpił nieoczekiwany błąd.",
  },
  list: {
    updated: "Zaktualizowano",
    status: "Status",
    synced: "Zsynchronizowany",
    delete: "Usuń",
    empty: "Brak zsynchronizowanych kalendarzy",
  },
  deleteConfirm: {
    title: "Czy usunąć kalendarz?",
    content:
      'Usunięcie kalendarza spowoduje również usunięcie rezerwacji zsynchronizowanych w menu "Zaplanowane check-iny (rezerwacje)"',
  },
  deleteSuccess: {
    message: "Kalendarz został usunięty",
    title: "Usunięto",
  },
  deleteError: {
    message: "Błąd podczas usuwania kalendarza",
    title: "Błąd",
  },
};
